/**
 * @generated SignedSource<<df113b3b9ef7366674e1b92c5439db84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewStep_preCheckoutTransaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReturningBuyerDeliveryOptionsView_preCheckoutTransaction">;
  readonly " $fragmentType": "CheckoutReviewStep_preCheckoutTransaction";
};
export type CheckoutReviewStep_preCheckoutTransaction$key = {
  readonly " $data"?: CheckoutReviewStep_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewStep_preCheckoutTransaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReviewStep_preCheckoutTransaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReturningBuyerDeliveryOptionsView_preCheckoutTransaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "44c40b7cab053a0270a8210302931e03";

export default node;
